module.exports = __webpack_public_path__ + "img/btn-9-hopper.7ca7a80d.png";